// Text editor modal for chart text overlays
export function createTextEditorModal(e, kchart) {
  if (e.overlay.name !== 'text') {
    return;
  }

  const currentText = e.overlay.extendData.text || "add Text here";
  const currentColor = e.overlay.extendData.color || "red";
  const currentSize = e.overlay.extendData.size || 16;
  
  // Detect current theme
  const isDarkTheme = document.documentElement.getAttribute('data-bs-theme') === 'dark' || 
                     document.body.getAttribute('data-bs-theme') === 'dark' ||
                     (window.localStorage.getItem('theme') === 'dark') ||
                     (!window.localStorage.getItem('theme') && window.matchMedia('(prefers-color-scheme: dark)').matches);
  
  // Create a modal dialog for editing
  const modal = document.createElement('div');
  
  // Define styles based on theme
  const modalStyles = isDarkTheme ? {
    background: '#2c3e50',
    borderColor: '#4a5568',
    color: '#e2e8f0',
    textColor: '#e2e8f0'
  } : {
    background: 'white',
    borderColor: '#ccc',
    color: '#333',
    textColor: '#333'
  };
  
  modal.style.cssText = `
    position: fixed;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    background: ${modalStyles.background};
    border: 2px solid ${modalStyles.borderColor};
    border-radius: 8px;
    padding: 30px;
    box-shadow: 0 4px 6px rgba(0, 0, 0, ${isDarkTheme ? '0.3' : '0.1'});
    z-index: 10000;
    min-width: 450px;
    max-width: 600px;
    width: 90vw;
    color: ${modalStyles.textColor};
  `;
  
  
  // Define input styles based on theme
  const inputStyles = isDarkTheme ? {
    background: '#374151',
    borderColor: '#4b5563',
    textColor: '#e2e8f0'
  } : {
    background: 'white',
    borderColor: '#ccc',
    textColor: '#333'
  };
  
  const buttonStyles = isDarkTheme ? {
    cancelBg: '#4b5563',
    cancelColor: '#e2e8f0',
    cancelBorder: '#6b7280',
    okBg: '#3b82f6',
    deleteBg: '#ef4444'
  } : {
    cancelBg: '#f8f9fa',
    cancelColor: '#333',
    cancelBorder: '#dee2e6',
    okBg: '#007bff',
    deleteBg: '#dc3545'
  };
  
  modal.innerHTML = `
    <h3 style="margin-top: 0; color: ${modalStyles.textColor};">Edit Text</h3>
    <div style="margin-bottom: 15px;">
    <label style="color: ${modalStyles.textColor};">Color:</label><br>
    <select id="colorSelect" style="width: 100%; padding: 8px; margin-top: 5px; font-size: 14px; background: ${inputStyles.background}; color: ${inputStyles.textColor}; border: 1px solid ${inputStyles.borderColor}; border-radius: 4px;">
      <option value="red" ${currentColor === 'red' ? 'selected' : ''}>Red</option>
      <option value="green" ${currentColor === 'green' ? 'selected' : ''}>Green</option>
      <option value="blue" ${currentColor === 'blue' ? 'selected' : ''}>Blue</option>
      <option value="orange" ${currentColor === 'orange' ? 'selected' : ''}>Orange</option>
      <option value="purple" ${currentColor === 'purple' ? 'selected' : ''}>Purple</option>
      <option value="black" ${currentColor === 'black' ? 'selected' : ''}>Black</option>
      <option value="white" ${currentColor === 'white' ? 'selected' : ''}>White</option>
    </select>
    </div>
    <div style="margin-bottom: 20px;">
    <label style="color: ${modalStyles.textColor};">Font Size:</label><br>
    <input type="range" id="sizeSlider" min="10" max="50" value="${currentSize}" style="width: 100%; margin-top: 8px;">
    <span id="sizeDisplay" style="font-weight: bold; color: ${modalStyles.textColor};">${currentSize}px</span>
    </div>
    <div style="margin-bottom: 15px;">
    <label style="color: ${modalStyles.textColor};">Text:</label><br>
    <textarea id="textInput" style="width: 100%; padding: 8px; margin-top: 5px; min-height: 120px; resize: vertical; font-family: inherit; font-size: 14px; border: 1px solid ${inputStyles.borderColor}; border-radius: 4px; background: ${inputStyles.background}; color: ${inputStyles.textColor};"></textarea>
    </div>
    <div style="text-align: right;">
    <button id="cancelBtn" style="display: none;margin-right: 15px; padding: 8px 20px; font-size: 14px; cursor: pointer; background: ${buttonStyles.cancelBg}; color: ${buttonStyles.cancelColor}; border: 1px solid ${buttonStyles.cancelBorder}; border-radius: 4px;">Cancel</button>
    <button id="okBtn" style="padding: 8px 20px; background: ${buttonStyles.okBg}; color: white; border: none; border-radius: 4px; font-size: 14px; cursor: pointer;">OK</button>
    <button id="deleteBtn" style="display:none;margin-left: 15px; padding: 8px 20px; background: ${buttonStyles.deleteBg}; color: white; border: none; border-radius: 4px; font-size: 14px; cursor: pointer;">Delete</button>
    </div>
  `;
  
  // Set textarea value after creating the element to preserve line breaks
  const textInput = modal.querySelector('#textInput');
  textInput.value = currentText;
  
  // Add backdrop
  const backdrop = document.createElement('div');
  backdrop.style.cssText = `
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, ${isDarkTheme ? '0.7' : '0.5'});
    z-index: 9999;
  `;
  
  document.body.appendChild(backdrop);
  document.body.appendChild(modal);
  
  // Add hover effects for buttons
  const cancelBtn = modal.querySelector('#cancelBtn');
  const okBtn = modal.querySelector('#okBtn');
  const deleteBtn = modal.querySelector('#deleteBtn');
  
  // Cancel button hover effects
  cancelBtn.addEventListener('mouseenter', () => {
    cancelBtn.style.background = isDarkTheme ? '#6b7280' : '#e9ecef';
  });
  cancelBtn.addEventListener('mouseleave', () => {
    cancelBtn.style.background = buttonStyles.cancelBg;
  });
  
  // OK button hover effects
  okBtn.addEventListener('mouseenter', () => {
    okBtn.style.background = isDarkTheme ? '#2563eb' : '#0056b3';
  });
  okBtn.addEventListener('mouseleave', () => {
    okBtn.style.background = buttonStyles.okBg;
  });
  
  // Delete button hover effects
  deleteBtn.addEventListener('mouseenter', () => {
    deleteBtn.style.background = isDarkTheme ? '#dc2626' : '#c82333';
  });
  deleteBtn.addEventListener('mouseleave', () => {
    deleteBtn.style.background = buttonStyles.deleteBg;
  });
  
  // Update size display when slider changes
  const sizeSlider = modal.querySelector('#sizeSlider');
  const sizeDisplay = modal.querySelector('#sizeDisplay');
  sizeSlider.addEventListener('input', () => {
    sizeDisplay.textContent = sizeSlider.value + 'px';
  });
  
  // Focus on text input and place cursor at the end
  setTimeout(() => {
    textInput.focus();
    // Set cursor position to the end of the text
    const textLength = textInput.value.length;
    textInput.setSelectionRange(textLength, textLength);
  }, 0);
  
  // Prevent keydown events from bubbling up except for Enter key
  textInput.addEventListener('keydown', (event) => {
    if (event.key === 'Enter' && event.ctrlKey) {
      // Ctrl+Enter to save
      modal.querySelector('#okBtn').click();
    } else if (event.key === 'Escape') {
      // ESC to close modal
      event.preventDefault();
      event.stopPropagation();
      closeModal();
    } else {
      // Stop propagation for all other keys to prevent triggering chart shortcuts
      event.stopPropagation();
    }
  });
  
  // Function to close modal
  const closeModal = () => {
    document.body.removeChild(backdrop);
    document.body.removeChild(modal);
    // Remove ESC key listener when modal is closed
    document.removeEventListener('keydown', handleEscKey);
  };
  
  // Handle ESC key to close modal
  const handleEscKey = (event) => {
    if (event.key === 'Escape') {
      event.preventDefault();
      event.stopPropagation();
      closeModal();
    }
  };
  
  // Add ESC key listener
  document.addEventListener('keydown', handleEscKey);
  
  // Handle buttons
  modal.querySelector('#okBtn').addEventListener('click', () => {
    const newText = modal.querySelector('#textInput').value;
    const newColor = modal.querySelector('#colorSelect').value;
    const newSize = parseInt(modal.querySelector('#sizeSlider').value);

    closeModal();
    if (newText.trim()) {
      e.overlay.extendData.text = newText;
      e.overlay.extendData.color = newColor;
      e.overlay.extendData.size = newSize;
      e.overlay.update();
    } else {
      kchart.removeOverlay(e.overlay);
    }
  });
  
  modal.querySelector('#cancelBtn').addEventListener('click', () => {
    closeModal();
  });
  
  modal.querySelector('#deleteBtn').addEventListener('click', () => {
    kchart.removeOverlay(e.overlay);
    closeModal();
  });
  
  // Close on backdrop click
  backdrop.addEventListener('click', () => {
    closeModal();
  });
}
